import { render } from "./TombstoneDialog.vue?vue&type=template&id=64447d52&scoped=true"
import script from "./TombstoneDialog.vue?vue&type=script&lang=js"
export * from "./TombstoneDialog.vue?vue&type=script&lang=js"

import "./TombstoneDialog.vue?vue&type=style&index=0&id=64447d52&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-64447d52"

export default script